(function () {

	const footer = () => {
		const footerDetails = document.querySelectorAll(
			'.footer .accordion details',
		);
		footerDetails.forEach((targetDetail) => {
			if (targetDetail.dataset.footerAccordionBound === 'true') {
				return;
			}

			targetDetail.dataset.footerAccordionBound = 'true';
			targetDetail.addEventListener('click', () => {
				footerDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});

	}

	if (document.documentElement.dataset.footerScriptBound === 'true') {
		return;
	}

	document.documentElement.dataset.footerScriptBound = 'true';

	document.addEventListener('shopify:section:load', footer);
	footer();

})();